module.exports = __webpack_public_path__ + "static/IrisUHome-be4f0994c495aef16807315ed7514206.png";